import { render } from "./CatalogPage.vue?vue&type=template&id=04600b20&scoped=true"
import script from "./CatalogPage.vue?vue&type=script&lang=js"
export * from "./CatalogPage.vue?vue&type=script&lang=js"

import "./CatalogPage.vue?vue&type=style&index=0&id=04600b20&lang=scss&scoped=true"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04600b20"]])

export default __exports__